/* Layout */
import Layout from '@/layout'

export default {
  path: '/ums',
  component: Layout,
  redirect: '/ums/user',
  name: 'ums',
  meta: { title: '权限管理', icon: 'permission' },
  children: [
    {
      path: 'user',
      name: 'user',
      component: () => import('@/views/ums/user/index'),
      meta: { title: '用户列表', icon: 'user' }
    },
    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/ums/menu/index'),
      meta: { title: '菜单列表', icon: 'menu' }
    },
    { path: 'role',
      name: 'role',
      component: () => import('@/views/ums/role/index'),
      meta: { title: '角色列表', icon: 'role' }
    },
    {
      path: 'client',
      name: 'client',
      component: () => import('@/views/client/index'),
      meta: { title: '公司列表', icon: 'company' }
    },
    {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/role/alloc'),
      meta: { title: '分配权限' },
      hidden: true
    }
  ]
}
